export function isLoading(state: any) {
    return state.app.isLoading;
}

export function getAppMenu(state: any) {
    return state.app.appMenu.items;
}

export function getSettings(state: any) {
    return state.app.settings;
}

export function getCustomPage(state: any) {
    return state.app.customPage;
}

export function getPageMeta(state: any) {
    return state.app.pageMeta;
}

export function getSideNavState(state: any) {
    return state.app.sideNavIsOpened;
}
